import React from 'react'

import { getSemanticDate } from '@utils/dayjs'

import DownloadButton from '@components/DownloadButton'
import Media from '../Media'
import Tags from '../Tags'

import styles from './styles.module.css'

const EntryModal = ({ entry }) => {
  return (
    <div className={styles.entryModal}>
      <Media autoPlay={true} media={entry.media} isModal={true} playsInline preload='metadata' />
      <div>
        <DownloadButton entry={entry} />

        <section>
          <h2>Posted</h2>
          <p>{getSemanticDate(entry.createdAt)}</p>
        </section>

        <section>
          <h2>Description</h2>
          <p>{entry.text}</p>
        </section>

        <section>
          <Tags entry={entry} />
        </section>
      </div>
    </div>
  )
}

export default EntryModal
